<template>
  <div
    id="primary-navigation"
    class="primary-navigation"
  >
    <div class="primary-navigation__tabs">
      <span class="primary-navigation__tab-entry primary-navigation__tab-entry--active">
        Privatkunden
      </span>
      <LinkButton
        tag="a"
        class="primary-navigation__tab-entry"
        href="https://geschaeftskunden.telekom.de/"
        rel="noopener"
        target="_blank"
        text-neutral
        is-external
      >
        Geschäftskunden
      </LinkButton>
    </div>
    <div
      class="primary-navigation__navigation-items-wrapper"
      :class="wrapperClass"
    >
      <NavigationItem
        v-for="navigationItem in navigationItems"
        :key="navigationItem.path"
        :navigation-item="navigationItem"
        @subnav-open="handleSubmenuToggle"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useNavigationStore } from '~/stores/navigation';
import { LinkButton } from '@i22team/td-longtail-vue-components';
import NavigationItem from './navigation-item-lazy';

const showSubNav = ref(0);

const { navigationItems } = storeToRefs(useNavigationStore());

const wrapperClass = computed(() => {
  if (showSubNav.value === 0) return '';
  return `primary-navigation__navigation-items-wrapper--open-${showSubNav.value}`;
});

const emit = defineEmits<{
  (e: 'subnav-open', value: number): void;
}>();

const handleSubmenuToggle = (value: number) => {
  showSubNav.value = value;
  emit('subnav-open', value);
};
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.primary-navigation {
  top: 100%;
  left: 0;
  right: 0;

  @include mq(false, $mq-lg - 1) {
    position: absolute;
    background: var(--color-bg);
    color: var(--color-font);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding-bottom: $grid-base * 4;
    height: calc(100vh - var(--nav-height-initial));
    box-shadow: 0 -1px 2px 0 rgb(from var(--color-inverse-bg) r g b / 0.15);
  }

  @include mq($mq-lg) {
    display: inline-flex;
    width: 100%;
  }

  body:not(.mobile-nav-open) & {
    display: none;

    /* show always on desktop */
    @include mq($mq-lg) {
      display: inline-flex;
    }
  }

  &__tabs {
    background: var(--color-background-subtle);
    display: flex;
    @include mq($mq-lg) {
      display: none;
    }
  }

  &__tab-entry {
    flex: 1 1 50%;
    font-weight: 800;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-block: 1rem;
    border-bottom: 1px solid var(--color-stroke-subtle);

    &--active {
      border-color: var(--color-primary);
      color: var(--color-primary);
    }
  }

  &__navigation-items-wrapper {
    @include mq(false, $mq-lg - 1) {
      margin-bottom: calc(
        env(safe-area-inset-bottom, 0) + 80px
      ); // add the bottom bar on Chrome / Brave
      transition: transform 0.4s ease-out;

      &--open-1 {
        transform: translateX(-100%);
      }
      &--open-2 {
        transform: translateX(-200%);
      }
    }

    @include mq($mq-lg) {
      display: flex;
      align-items: center;
    }
  }
}
</style>
